import { BaseService } from './BaseService';

/**
 * Contact Type Service Class
 * Handles all contact type related API operations
 */
class ContactTypeService extends BaseService {
    constructor() {
        super('/api/contactTypes');
    }

    /**
     * Validate contact type data
     * @param {Object} data - Contact type data
     */
    validateContactTypeData(data) {
        if (!data.contactType || typeof data.contactType !== 'string') {
            throw new Error('Contact type name is required and must be a string');
        }
        
        if (data.contactType.trim().length === 0) {
            throw new Error('Contact type name cannot be empty');
        }
        
        if (data.contactType.length > 50) {
            throw new Error('Contact type name cannot exceed 50 characters');
        }
        
        if (data.description && data.description.length > 254) {
            throw new Error('Contact type description cannot exceed 254 characters');
        }
    }

    /**
     * Create a new contact type with validation
     * @param {string} accessToken - JWT access token
     * @param {Object} data - Contact type data
     * @returns {Promise<Object>} Created contact type object
     */
    async create(accessToken, data) {
        this.validateContactTypeData(data);
        return super.create(accessToken, data);
    }

    /**
     * Update an existing contact type with validation
     * @param {string} accessToken - JWT access token
     * @param {number} id - Contact type ID
     * @param {Object} data - Updated contact type data
     * @returns {Promise<Object>} Updated contact type object
     */
    async update(accessToken, id, data) {
        this.validateContactTypeData(data);
        return super.update(accessToken, id, data);
    }
}

// Export singleton instance
export const contactTypeService = new ContactTypeService();

// Export individual methods for convenience
export const {
    getAll: getAllContactTypes,
    getById: getContactTypeById,
    create: createContactType,
    update: updateContactType,
    delete: deleteContactType,
    search: searchContactTypes
} = contactTypeService;

export default contactTypeService;
